/** Exact raw source photos that correspond to an excluded mirrored image. */
const EXCLUDED_SOURCE_BY_MIRROR: Readonly<Record<string, string>> = {
  'fridge-com-ge-gde03ggkbb-1.jpg': 'https://m.media-amazon.com/images/I/31EG0v7xjoL._SL500_.jpg',
  'fridge-com-marvel-appliances-mpre424sg81a-1.jpg': 'https://assets.ajmadison.com/image/upload/v1/ajmadison/images/large_no_watermark/mpre424ss81a-16256ea5b0d5041.05196395_e5abe.jpg',
  'fridge-com-frigidaire--1.jpg': 'https://d229whyy0854hb.cloudfront.net/pi/4203/paultra-eafcbf_datafeed-1-v13.jpg',
  'fridge-com-koolmore-km-gf25-bk-1.jpg': 'https://assets.wfcdn.com/im/69421755/resize-h1600-w1600%5Ecompr-r85/2919/291901804/.jpg',
  'fridge-com-ge-gts22kynrfs-1.jpg': 'https://images.webfronts.com/cache/fruftmegmdsv.jpg',
  'fridge-com-ge-gts18hynrfs-1.jpg': 'https://images.webfronts.com/cache/frxbnnlapwrc.jpg',
  'fridge-com-ge-pge29bytfs-1.jpg': 'https://d2j6dbq0eux0bg.cloudfront.net/images/96969269/4306021891.jpg',
  'fridge-com-avanti-nimd3323s-1.jpg': 'https://assets.ajmadison.com/image/upload/c_pad,f_auto,fl_lossy.progressive,q_auto,w_1200/v1/ajmadison/images/large_no_watermark/ff10b3s_main_1024x618500f444c9d6.04663435_1fb90.jpg',
  'fridge-com-avanti-av160vfk0w-1.jpg': 'https://assets.ajmadison.com/image/upload/c_pad,f_auto,fl_lossy.progressive,q_auto,w_1200/v1/ajmadison/images/large_no_watermark/ff10b3s_main_1024x618500f444c9d6.04663435_1fb90.jpg',
}

function basename(url: string): string {
  const noQuery = url.split(/[?#]/)[0]
  return (noQuery.split('/').filter(Boolean).pop() ?? noQuery).toLowerCase()
}

/** Prevent an excluded mirror from resurfacing through its exact raw source. */
export function dropExcludedProductSourceImages(images: string[], mirrors: string[]): string[] {
  const excludedSources = new Set(mirrors.map((url) => EXCLUDED_SOURCE_BY_MIRROR[basename(url)]).filter(Boolean))
  if (excludedSources.size === 0) return images
  return images.filter((url) => !excludedSources.has(url.split(/[?#]/)[0]))
}
